import { render, staticRenderFns } from "./KurccFormMultiChoiceAdditionalButtonsReportIssue.vue?vue&type=template&id=67a425f7&"
import script from "./KurccFormMultiChoiceAdditionalButtonsReportIssue.vue?vue&type=script&lang=js&"
export * from "./KurccFormMultiChoiceAdditionalButtonsReportIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VIcon,VRow,VSpacer,VTextField,VTextarea})
